import React, { useState } from 'react';
import { useSuperAdminAuth } from '../contexts/SuperAdminAuthContext';
import './SuperAdminLogin.css';

const SuperAdminLogin: React.FC = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  
  const { login } = useSuperAdminAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const success = await login(credentials.username, credentials.password);
      if (!success) {
        setError('Credenziali non valide');
      }
    } catch (error) {
      setError('Errore durante il login');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="superadmin-login-container">
      <div className="superadmin-login-card">
        <div className="superadmin-login-header">
          <h1>🔧 Super Admin</h1>
          <p>Accesso alla gestione piattaforma</p>
        </div>
        
        <form onSubmit={handleSubmit} className="superadmin-login-form">
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading || !credentials.username || !credentials.password}
          >
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </button>
        </form>
        
        <div className="superadmin-login-footer">
          <p>⚠️ Accesso riservato agli amministratori di piattaforma</p>
          <a href="/" className="back-link">← Torna all'applicazione</a>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
